import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectTextLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 4.5h3A1.5 1.5 0 0 1 20.5 6v12a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V6A1.5 1.5 0 0 1 16 4.5M13 6a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3zM2 5.75A.75.75 0 0 1 2.75 5h7.015a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 6a.75.75 0 0 1 .75-.75h7.015a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M5.75 8a.75.75 0 1 0 0 1.5h4.015a.75.75 0 0 0 0-1.5zM5 14.75a.75.75 0 0 1 .75-.75h4.015a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextLeft24);
